module.exports = __webpack_public_path__ + "static/media/3-7.85fb8e0e.mp3";